import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-240 min-h-192" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "py-4 pl-4 font-light font-roboto text-blue-800 text-2xl" }, " Aruande koostamine ", -1)
const _hoisted_3 = { class: "w-full inline-flex items-center space-x-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
}, " Lae PDF alla ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddImageForm = _resolveComponent("AddImageForm")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_ModalWrapper = _resolveComponent("ModalWrapper")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-wrapper" }, [
    _createVNode(_component_ModalWrapper, {
      open: _ctx.isOpen,
      onOnclose: _ctx.onClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("form", {
            class: "space-y-6",
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadPDF && _ctx.loadPDF(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.logo)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "h-28 w-64 bg-contain bg-center bg-no-repeat rounded-md",
                    style: _normalizeStyle({ 'background-image': `url(${_ctx.logo})` })
                  }, null, 4))
                : _createCommentVNode("", true),
              _createVNode(_component_AddImageForm, {
                class: "w-36",
                onOnLogo: _ctx.onLogo,
                haveLogo: !!_ctx.logo
              }, null, 8, ["onOnLogo", "haveLogo"])
            ]),
            _createVNode(_component_InputField, {
              label: "Aruande aasta",
              isAutocomplete: false,
              fieldId: "reportYearFieldID",
              inputType: _ctx.InputFieldType.NUMBER,
              value: _ctx.reportYear,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reportYear) = $event))
            }, null, 8, ["inputType", "value"]),
            _createVNode(_component_InputField, {
              label: "Kiirgustegevuse luba",
              isAutocomplete: false,
              fieldId: "licenseNumberFieldID",
              value: _ctx.licenseNumber,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.licenseNumber) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Esitaja nimi",
              isAutocomplete: false,
              fieldId: "userNameFieldID",
              value: _ctx.userName,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userName) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Ettevõtte nimi",
              isAutocomplete: false,
              fieldId: "companyNameFieldID",
              value: _ctx.companyName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyName) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Ettevõtte e-mail",
              isAutocomplete: false,
              fieldId: "companyEmailFieldID",
              value: _ctx.companyEmail,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companyEmail) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Perioodi algus",
              isAutocomplete: false,
              fieldId: "date1FieldID",
              value: _ctx.date1,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.date1) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Perioodi lõpp",
              isAutocomplete: false,
              fieldId: "date2FieldID",
              value: _ctx.date2,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.date2) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Asutuse nimi",
              isAutocomplete: false,
              fieldId: "buildingNameFieldID",
              value: _ctx.buildingName,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.buildingName) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Kiirgustegeuse asukoht",
              isAutocomplete: false,
              fieldId: "AddressFieldID",
              value: _ctx.Address,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.Address) = $event))
            }, null, 8, ["value"]),
            _createVNode(_component_InputField, {
              label: "Mõõtmis meetod",
              isAutocomplete: false,
              fieldId: "measurementMethodFieldID",
              value: _ctx.measurementMethod,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.measurementMethod) = $event))
            }, null, 8, ["value"]),
            _hoisted_4
          ], 32)
        ])
      ]),
      _: 1
    }, 8, ["open", "onOnclose"])
  ]))
}